import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import System, { SYSTEM } from '@shared/constants/system';

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss']
})
export class AuthLayoutComponent implements OnInit {
  isDesktop = true;
  isSystem: string;
  logo: string;

  constructor(private deviceService: DeviceDetectorService) {
  }

  ngOnInit(): void {
    this.isDesktop = this.deviceService.isDesktop();
    this.isSystem = System.getSystem();
    console.log('isSystem', this.isSystem);
    this.logo = this.isSystem === SYSTEM.B2B ? '-' + SYSTEM.B2B.toLowerCase() : '';
  }

}
